import { render, staticRenderFns } from "./CascoAjanlatAdatokB3_V0.vue?vue&type=template&id=2acd92fa&"
import script from "./CascoAjanlatAdatokB3_V0.vue?vue&type=script&lang=js&"
export * from "./CascoAjanlatAdatokB3_V0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports